/** @jsx jsx */
import { jsx } from 'theme-ui'
import { number, string } from 'prop-types'

const Bookmark = ({ color = 'forest', height = 20, ...props }) => {
  return (
    <svg
      width={10}
      height={height}
      viewBox="0 0 10 20"
      sx={{ fill: color }}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 15.084l-3-3.077-3 3.077V2h6v13.084zM0 0v20l5-5.128L10 20V0H0z"
      />
    </svg>
  )
}

Bookmark.propTypes = {
  color: string,
  height: number,
}

export default Bookmark
